// embed-playbuzz/client.js
// Component code for playbuzz embeds
// JS to initiate after DOMReady.
export default function () {
  if (typeof PlayBuzz === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://cdn.playbuzz.com/widget/feed.js';
    document.body.appendChild(script);
  }
}
